/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    declare var SwaggerParser;

    export class DataSourceService extends services.DataService<Wars.Domain.Model.DataSource> {
        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
        }

        public getDataSources(id?: string): ng.IPromise<Wars.Domain.Model.DataSource[]> {
            let query = this.breezeModule.EntityQuery.from("DataSources");

                if (id){
                    query = query.where("processConfiguration_id","==", id);
                }else{
                    query = query.where("processConfiguration_id", "==", null);
                }

                query = query.expand("operations.parameters.parmeterSchema, objectSchemas.properties.codeGroup.codes, objectSchemas.properties.typeSchema");

            return this.executeQuery(query);

        }
        public createNewDataOperation(): models.DataOperation {
            return this.createNewEntity<models.DataOperation>("DataOperation");
        }
        public createNewDataOperationParameter(): Wars.Domain.Model.DataOperationParameter{
            return this.createNewEntity<Wars.Domain.Model.DataOperationParameter>("DataOperationParameter");
        }
        public parseSwaggerUrl(url: string): ng.IPromise<any> {
            return (<any>SwaggerParser).parse(url);

        }
        public createNewObjectSchema(): Wars.Domain.Model.ObjectSchema {
            let obj = this.createNewEntity<Wars.Domain.Model.ObjectSchema>("ObjectSchema");
            obj.isList = false;
            obj.uniqueIdentifier = services.UtilityService.generateGuidComb();
            return obj;
        }
        public createNewSchemaProperty(): Wars.Domain.Model.SchemaProperty{
            var prop = this.createNewEntity<Wars.Domain.Model.SchemaProperty>("SchemaProperty");
            prop.required = true;
            prop.isIndexed = false;
            prop.isSystemLevel = false;
            prop.uniqueIdentifier = services.UtilityService.generateGuidComb();

            return prop;
        }
    }
}

warsApp.registerService('DataSourceService', ['breeze', '$q']);